// 8. COMPOSANT POUR LES ÉLÉMENTS AJOUTÉS
// components/consultation/AddedItemsSection.tsx
import React from "react";
import { AnalysesList } from "./AnalysesList";
import { MedicationsList } from "./MedicationsList";
import type { Analyse } from "../../../types/analyse";
import type { Medication } from "../../../types/medication";

interface AddedItemsSectionProps {
  analyses: Analyse[];
  medications: Medication[];
  onAddAnalyse: () => void;
  onEditAnalyse: (index: number) => void;
  onDeleteAnalyse: (index: number) => void;
  onAddMedication: () => void;
  onDeleteMedication: (index: number) => void;
}

export const AddedItemsSection: React.FC<AddedItemsSectionProps> = ({
  analyses,
  medications,
  onAddAnalyse,
  onEditAnalyse,
  onDeleteAnalyse,
  onAddMedication,
  onDeleteMedication,
}) => {
  if (analyses.length === 0 && medications.length === 0) {
    return null;
  }

  return (
    <div className="mt-8 space-y-4">
      <h4 className="text-lg font-bold text-gray-800">Éléments ajoutés :</h4>
      
      <AnalysesList
        analyses={analyses}
        onAdd={onAddAnalyse}
        onEdit={onEditAnalyse}
        onDelete={onDeleteAnalyse}
      />

      <MedicationsList
        medications={medications}
        onAdd={onAddMedication}
        onDelete={onDeleteMedication}
      />
    </div>
  );
};